import { render } from "./Footer.vue?vue&type=template&id=3e79df0c&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=3e79df0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e79df0c"]])

export default __exports__